module.exports = __webpack_public_path__ + "static/media/splash-icon.866bf02f.png";